module.exports = __webpack_public_path__ + "media/images/LearnMore32-a8d1f4f58abe3a855b5b1f90205ed3d8.png";